import { ACTIONS } from "app/store/actions"
import { IMediaApprovalData, ISspMediaApproval, ISspMediaApprovalFilters } from "media/model"
import { Action } from "redux"

export interface IMediaApprovalActionSetList extends Action {
  mediaApprovalsData: IMediaApprovalData[]
}

export interface IMediaApprovalActionSetIsFilterExpanded extends Action {
  isFilterExpanded: boolean
}

export interface IMediaApprovalActionSetFilters extends Action {
  filteredMediaApprovalsData: IMediaApprovalData[]
  filters: ISspMediaApprovalFilters
}

export interface IMediaApprovalActionUpdateMediaApproval extends Action {
  mediaApproval: ISspMediaApproval
}

export const mediaActionCreator = {
  startMediaApprovalLoading(): Action {
    return {
      type: ACTIONS.MEDIA_APPROVAL_START_LOADING
    }
  },
  setHasError(isPending: boolean): Action {
    return {
      type: ACTIONS.MEDIA_APPROVAL_HAS_ERROR
    }
  },
  setMediaApprovalList(mediaApprovalsData: IMediaApprovalData[]): IMediaApprovalActionSetList {
    return {
      type: ACTIONS.MEDIA_APPROVAL_SET_LIST,
      mediaApprovalsData
    }
  },
  setMediaApprovalFilters(
    filteredMediaApprovalsData: IMediaApprovalData[],
    filters: ISspMediaApprovalFilters
  ): IMediaApprovalActionSetFilters {
    return {
      type: ACTIONS.MEDIA_APPROVAL_SET_FILTERS,
      filteredMediaApprovalsData,
      filters
    }
  },
  setFilterExpansion(isFilterExpanded: boolean): IMediaApprovalActionSetIsFilterExpanded {
    return {
      type: ACTIONS.MEDIA_APPROVAL_SET_FILTER_IS_EXPANDED,
      isFilterExpanded
    }
  },
  startUpdatingMediaApproval(): Action {
    return {
      type: ACTIONS.MEDIA_APPROVAL_START_UPDATING
    }
  },
  stopUpdatingMediaApproval(): Action {
    return {
      type: ACTIONS.MEDIA_APPROVAL_STOP_UPDATING
    }
  },
  updateMediaApproval(mediaApproval: ISspMediaApproval): IMediaApprovalActionUpdateMediaApproval {
    return {
      type: ACTIONS.MEDIA_APPROVAL_UPDATE,
      mediaApproval
    }
  }
}
